import React, { useState } from 'react'
import firebase from "../data/firebase"
import { Redirect } from 'react-router-dom'


const Login = () => {

	const [email, setEmail] = useState("")
	const [senha, setSenha] = useState("")
	const [usuarioLogado, setUsuarioLogado] = useState(false)

	const login = async () => {
		try {
			const response = await firebase.login(email, senha)
			setUsuarioLogado(true)
		} catch (error) {
			alert(error.message)
		}
	}

	const usuarios = []

	const criarUsuarios = () => {
		usuarios.forEach(usuario => {
			firebase.db.collection("usuarios").doc(usuario.email.toLowerCase()).set({ email: usuario.email.toLowerCase(), token: usuario.matricula.slice(0, 6) })
			// firebase.auth.createUserWithEmailAndPassword("edionay@gmail.com", usuario.matricula.slice(0,6)).then(response)
		})
	}

	return (
		usuarioLogado ? (<Redirect to="agendamento" />) : (
			<form>
				<button onClick={(event) => {
					event.preventDefault()
					criarUsuarios()
				}}>criar usuarios</button>
				<div class="form-group">
					<label for="exampleInputEmail1">Email addres</label>
					<input onChange={(event) => setEmail(event.target.value)} type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
					<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
				</div>
				<div class="form-group">
					<label for="exampleInputPassword1">Password</label>
					<input onChange={(event) => setSenha(event.target.value)} type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" />
				</div>
				<div class="form-check">
					<input type="checkbox" class="form-check-input" id="exampleCheck1" />
					<label class="form-check-label" for="exampleCheck1">Check me out</label>
				</div>
				<button onClick={(event) => {
					event.preventDefault()
					login()
				}} class="btn btn-primary">Submit</button>
			</form>))
}

export default Login